<div class="container-fluid">
  <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && submitForm(productResult)" class="form-inline required" novalidate>
    <div *ngIf="!editId" class="add">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Add PurchaseOrder</h4>
        <div class="headerButton">
          <button class="btn btn-success">
            <i aria-hidden="true" class="fa fa-floppy-o"></i> Confirm
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- <div class="form-group col-lg-4">
                <label class="required" for="datePick"> Date: </label>
                <input [(ngModel)]="headObj.datePick" #date="ngModel" class="form-control" id="datePick" name="date" [ngClass]="{ 'is-invalid': f.submitted && date.invalid }" required
                       type="text">
              </div> -->
              <div class="form-group col-lg-4">
                <label class="" for="selectedLocation">Countries: </label>
                <select (change)="selectedLocationFn($event)" [(ngModel)]="selectedLocation" class="form-control" data-show-content="true"
                        id="selectedLocation" name="country" #country="ngModel" [ngClass]="{ 'is-invalid': f.submitted && country.invalid }" required>
                  <option>Select Country</option>
                  <option *ngFor="let loc of Countries" [value]="loc.id"> {{loc.name}} </option>
                </select>

              </div>
              <div class="form-group col-lg-4">
                <label for="city">City: </label>
                <select [(ngModel)]="headObj.warehouse" class="form-control" data-show-content="true" id="city"
                        name="city" #city="ngModel" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required>
                  <option>Select Warehouse</option>
                  <option *ngFor="let ware of locationData" [value]="ware.id"> {{ware.name}} </option>

                </select>
              </div>
            </div>
            <p class="MandRequired" style="color: red;margin-bottom: 0px">
              Please Enter Mandatory Field
            </p>
            <div class="row col-lg-12 col-md-12 col-sm-3">
              <div class="table-responsive">
                <table class="table table-responsive table-bordered invoiceTable">
                  <thead>
                  <th class="col-xs-2 labelRequired" scope="col">Code</th>
                  <th scope="col">Product</th>
                  <th class="labelRequired" scope="col">Quantity</th>
                  <th (click)="calculate()" class="labelRequired" scope="col">Rate</th>
                  <th  class="labelRequired" scope="col">Discount(%)<!-- / Amount --></th>

                  <th scope="col">Amount</th>
                  </thead>
                  <tbody>
                  <tr #addAtribute *ngFor="let row of productResult; let i=index">
                    <td>
                       <div class="input-group">
                        <input type="text" size="4" class="form-control" [value]="row.code" name="{{'code'+i}}" #code="ngModel" id="{{'Code'+i}}" [(ngModel)]="row.code" required [ngClass]="{ 'is-invalid': f.submitted && code.invalid }">
                          <span class="input-group-btn iconsSize">
                              <button (click)="openProductModal(i)" class="btn btn-default"
                                    type="button">
                                <i class="fa fa-search"></i>
                            </button>
                          </span>
                      </div>
                    </td>
                    <td><input class="form-control" [value]="row.name" readonly style="width: 100%" type="text"></td>
                     <td>
                      <input type="text" size="4" class="form-control"  name="{{'quantity'+i}}"  #quantity="ngModel" [value]="row.quantity" [(ngModel)]="row.quantity" required [ngClass]="{ 'is-invalid': f.submitted && quantity.invalid }">
                    </td>
                    <td>
                      <input type="text" size="8"class="form-control"  (blur)="blur($event,'amount',i)" name="{{'amount'+i}}" #amount="ngModel" [(ngModel)]="row.amount" required [ngClass]="{ 'is-invalid': f.submitted && amount.invalid }">
                    </td>
                    <td><input class="form-control"  (blur)="blur($event,'discount',i)" #discount="ngModel" [value]="row.discount" [(ngModel)]="row.discount" required [ngClass]="{ 'is-invalid': f.submitted && discount.invalid }" name="{{'discount'+i}}"size="3" style="width: 50% !important;" type="text"/> <span *ngIf="row.discount > '0'"> / {{ (row.quantity * row.amount) - row.rate | number }}</span></td>
                    <td>
                      <div class="input-group">
                        <input class="form-control"  [value]="row.rate"  readonly size="10" type="text" name="{{'indexamount'+i}}"/>
                        <span [hidden]="i == 0" class="input-group-btn cancelIcon">
                       <button class="btn btn-default" type="button">
                        <i (click)="deleteRow(i)" aria-hidden="true"class="fa fa-times" style="color: red"></i>
                        </button>
                            </span>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <button (click)="addRow()" class="btn btn-success btn-sm"
                              type="button">Add row
                      </button>
                    </td>
                    <td colspan="2"> Grant Total</td>
                    <td>
                      <div class="input-group">
                        <input class="form-control"  [value]="totals.gT" name="grant_ttl" size="10" type="text"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td colspan="2"> Discount</td>
                    <td>
                      <div class="input-group">
                        <input class="form-control"  (blur)="blurDis($event)" [value]="totals.d" size="10"
                               type="text"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td colspan="2"> Net total</td>
                    <td>
                      <div class="input-group">
                        <input class="form-control"  [value]="totals.nT" name="net_total" size="10" type="text"/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>

    <div *ngIf="editId" class="edit">
      <div class="ModalHeader">
        <h2 *ngIf="approvalPermission" mat-dialog-title>Sales Orders</h2>
        <!-- <h2 *ngIf="approvalPermission === false" mat-dialog-title>View Purchase Orders</h2> -->
        <div class="headerButton">
          <!--<button *ngIf="approvalPermission" class="btn btn-success" (click)="submitTypeChange()">
            <i aria-hidden="true" class="fa fa-thumbs-o-upo"></i> Approve
          </button>
          <button *ngIf="reorderPermission" class="btn btn-dark" (click)="submitReorder()">
            <i aria-hidden="true" class="fa fa-thumbs-o-upo"></i> Reorder
          </button>
          <button *ngIf="editPermission" class="btn btn-success">
            <i aria-hidden="true" class="fa fa-floppy-o"></i> Save
          </button>
          <button  *ngIf="approvalPermission" (click)="close()" class="btn btn-warning" matDialogClose type="button">
            <i aria-hidden="true" class="fa fa-times"></i> Cancel
          </button> -->
          <button  (click)="close()" class="btn btn-warning" matDialogClose type="button">
            <i aria-hidden="true" class="fa fa-times"></i> Close
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-lg-4">
                <span> SO Date: <br>{{editObj.po_date}}</span>
              </div>
              <div class="form-group col-lg-4">
                <span>Country: <br> {{editObj.country_id}}</span>
              </div>
              <div class="form-group col-lg-4">
                <span>City: <br> {{editObj.city_id}}</span>
              </div>
            </div>
            <div class="row col-lg-12 col-md-12 col-sm-3">
              <div class="table-responsive">
                <table class="table table-responsive table-bordered invoiceTable ">
                  <thead>
                  <th class="col-xs-2 " scope="col">Code</th>
                  <th scope="col">Product</th>
                  <th class="" scope="col">Quantity</th>
                  <th (click)="calculate()" class="" scope="col">Rate</th>
                  <th class="" scope="col">Discount(%)<!-- / Amount --></th>

                  <th scope="col">Amount</th>
                  </thead>

                  <tbody>

                  <tr #addAtribute *ngFor="let row of items; let i=index">
                    <td><div class="input-group"><span>{{row.code}}</span></div></td>

                    <td><div class="input-group"><span>{{row.name}}</span></div></td>

                    <td><div class="input-group"><span>{{row.quantity}}</span></div></td>

                    <td><div class="text-right"><span>{{row.rate | number:'1.2-2'}}</span></div></td>

                    <td><div class="text-right"><span>{{row.discount | number:'1.2-2'}}</span></div></td>
                    <td><div class="text-right"><span>{{row.amount | number:'1.2-2'}}</span></div></td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <!--<button *ngIf="editPermission" (click)="addRow()" class="btn btn-success btn-sm"
                              type="button">Add Row
                      </button>-->
                    </td>
                    <td colspan="2"> Grant Total</td>
                    <td><div class="text-right"><span>{{editObj.grand_total | number:'1.2-2'}}</span></div></td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td colspan="2"> Discount</td>
                    <td>
                      <div class="text-right"><span>{{editObj.total_discount | number:'1.2-2'}}</span></div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3"></td>
                    <td colspan="2"> Net total</td>
                    <td>
                      <div class="text-right"><span>{{editObj.net_total | number:'1.2-2'}}</span></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>

        </div>


      </mat-dialog-content>
    </div>

  </form>

</div>
